import React, {useState} from "react";
import {Grid,Typography,Paper,Button, useTheme} from "@material-ui/core";
import Subscription_addon_popup from './Subscription_addon_popup';
import axios from 'axios';


const SingleAddon = ({ addon, isActive, onClick, handleEdit, handleDelete }) => {
  if (!addon) {
    return null; // or display a loading state/error message
  }

  const { name, description, price, image, topup, interval } = addon;
  const theme = useTheme();

  const containerStyle = {
    padding: '20px',
    position: 'relative',
    zIndex: isActive ? 'unset' : 1,
    cursor:'pointer',
    boxShadow: isActive ? 'inset rgba(0, 0, 0, 0.5) 0px 1px 3px' : '0px 1px 3px rgba(0, 0, 0, 0.5)',
    backgroundColor: isActive ? theme.palette.background.main : theme.palette.background.main,
    animation: isActive ? 'none' : '$flash 1.5s infinite', // Add the flash animation
  };

  const imageStyle = {
    width: 'calc(100% + 40px)', // Increase the width to cover the left margin
    height: 'calc(100% + 40px)', // Increase the height to cover the top and bottom margin
    objectFit: 'cover',
    borderRadius: '4px 0 0 4px', // Apply border radius to top left and bottom left corners only
    position: 'absolute', // Use absolute positioning for the image
    top: '-20px', // Adjust the top value to align with the container border
    left: '-20px', // Adjust the left value to align with the container border
  };

  const textContainerStyle = {
    paddingLeft: '20px',
  };

  const buttonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
  };
  console.log('ART');
  return (
    <Paper elevation={3} style={containerStyle} onClick={onClick}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <div style={{ position: 'relative', height: '100%', backgroundColor:'white'}}>
            <img src={image} alt="Addon" style={imageStyle} />
          </div>
        </Grid>
        <Grid item xs={9} style={textContainerStyle}>
          <Typography variant="h6" style={{marginTop:'-10px'}}>{name}</Typography>
          {(interval=='YEAR')?<Typography variant="body2" color={(theme.palette.background.main=='#e8ddbf')?undefined:"secondary"}>Price per year: {price}</Typography>:<Typography variant="body2" color={(theme.palette.background.main=='#e8ddbf')?undefined:"secondary"}>Price per month: {price}</Typography>}
          <Typography variant="body2">Extra credits: {topup}</Typography>
          <Typography variant="caption"><div dangerouslySetInnerHTML={{__html:description}}/></Typography>
        </Grid>
      </Grid>
      <style>{`@keyframes flash {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.65; transform: scale(1.15); }
        100% { opacity: 1; transform: scale(1); }
      }`}</style>

    </Paper>
  );
};



export default SingleAddon;
